module.exports = __webpack_public_path__ + "img/home-05.980be5c5.svg";